import React from "react";

export const Helpline = () => {
  return (
    <div className="helpline">
      <h4>
        Indian government and Ministry of Health & Family Welfare has provided the following helpline numbers<br></br> Source : <a href="https://www.mohfw.gov.in/">https://www.mohfw.gov.in/</a>
      </h4>
      <div className="helpcards">
        <div className="col-md-3">
          <div className="card-header">National Helpline</div>
          <div className="card-body">
            <strong>1075</strong>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card-header">Central Helpline</div>
          <div className="card-body">
            <strong>+91-11-23978043</strong>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card-header">MyGov Whatsapp</div>
          <div className="card-body">
            <strong>+91-90131-51515</strong>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card-header">Helpline Email</div>
          <div className="card-body">
            <strong>ncov2019@gmail.com</strong>
          </div>
        </div>
      </div>
    </div>
  );
};
